import React, { useEffect, useState } from "react";
import localeText from "../../../../locale";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import OrderService from "../../../../service/OrderService";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { formatDate } from "../../../../utilities/formatDate";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { formatPrice } from "../../../../utilities/formatPrice";
import UserInitialsAvatar from "../../../../components/UserInitialsAvatar/UserInitialsAvatar";

const FringeBenefitsPurchases = () => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const [purchases, setPurchases] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingDownload, setIsLoadingDownload] = useState({});

  const filters2 = {
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "fringeBenefit.user.username": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    formatedDate: { value: null, matchMode: FilterMatchMode.EQUALS },
  };

  const orderService = new OrderService();

  const getPurchases = async () => {
    try {
      setIsLoading(true);

      const res = await orderService.getFringeBenefitsPurchases();

      if (res.messageCode !== 200001) {
        showErrorToast({ code: res.messageCode });
        return;
      }
      console.log(res.result);
      setPurchases(res.result);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const getDownloadPurchase = async (id) => {
    try {
      setIsLoadingDownload((prev) => ({ ...prev, [id]: true }));

      const res = await orderService.getDownloadFringeBenefitsPurchase(id);

      const url = window.URL.createObjectURL(new Blob([res], { type: "application/pdf" }));
      const link = document.createElement("a");

      link.href = url;
      link.download = `purchase-${id}.pdf`;
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showSuccessToast({ detail: "fringeBenefitDownloadedSuccessfully" });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoadingDownload((prev) => ({ ...prev, [id]: false }));
    }
  };

  useEffect(() => {
    getPurchases();
  }, []);

  return (
    <div>
      <div className="card border-1 border-300">
        <h3 className="my-4">{localeText("purchases")}</h3>
        <hr />

        <DataTable
          value={purchases}
          paginator
          responsiveLayout="scroll"
          loading={isLoading}
          filters={filters2}
          filterDisplay="row"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={localeText("showingFirstToLast")}
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
        >
          <Column
            header={localeText("sellerProfilePic")}
            style={{ width: "10%" }}
            body={(order) => {
              return (
                <UserInitialsAvatar
                  avatarUrl={order?.fringeBenefit?.user?.urlAvatar}
                  firstName={order?.fringeBenefit?.user?.firstname}
                  lastName={order?.fringeBenefit?.user?.surname}
                  fullName={order?.fringeBenefit?.user?.username}
                  className="layout-dashboard-urlavatar"
                  alt="seller-avatar"
                />
              );
            }}
          ></Column>
          <Column
            field="id"
            header={"ID"}
            style={{ width: "20%" }}
            filter
            filterPlaceholder={localeText("search")}
            filters={filters2}
            filterDisplay="row"
            sortable
          />
          <Column
            field={"fringeBenefit.user.username"}
            style={{ width: "20%" }}
            header={localeText("seller")}
            sortable
            filter
            filterPlaceholder={localeText("searchBySeller")}
            filters={filters2}
            filterDisplay="row"
          />
          <Column
            header={localeText("preview")}
            body={(order) => {
              return (
                <div className="flex">
                  <AdvancedImage
                    cldImg={cloudinaryInstance
                      .image(order.fringeBenefit.imageid1)
                      .resize(fill().width(50).height(50))
                      .format("webp")}
                    style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                    className="border-round mr-3"
                    height={50}
                  />
                </div>
              );
            }}
            style={{ width: "30%" }}
          />
          <Column field="quantity" header={localeText("itemsQuantity")} style={{ width: "10%" }} />
          <Column
            header={localeText("status")}
            body={(order) => {
              return (
                <span
                  className="team-member-role text-0 p-1 border-round"
                  style={{ backgroundColor: order.status === "PAID" ? "#46a748" : "#F7B005" }}
                >
                  {localeText(order.status?.toLowerCase()).toUpperCase()}
                </span>
              );
            }}
            sortable
            field="status"
          ></Column>
          <Column
            header={localeText("total")}
            body={(order) => {
              return (
                <span>
                  {order.fringeBenefit.currency} {formatPrice(order.totalOrder)}
                </span>
              );
            }}
            field="total"
          ></Column>
          <Column
            header={localeText("date")}
            body={(order) => {
              return <p>{formatDate(new Date(order.dateOrder))}</p>;
            }}
            sortable
            field="date"
          />
          <Column
            header={`${localeText("download")} Voucher`}
            body={(order) => {
              return (
                <Button
                  icon="pi pi-download"
                  onClick={() => getDownloadPurchase(order.id)}
                  className="p-button-help p-button-rounded"
                  loading={isLoadingDownload[order.id] === true}
                  disabled={order.status !== "PAID"}
                  style={{ textSize: "4em" }}
                />
              );
            }}
            style={{ width: "10%" }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default FringeBenefitsPurchases;
